import React from 'react';
import Modal from 'react-modal';
import { DOCUMENTS } from '../constants/config';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '40px',
    borderRadius: '20px',
    maxWidth: '600px',
    width: '90%',
    maxHeight: '80vh',
    overflow: 'hidden'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000
  }
};

Modal.setAppElement('#root');

function DocumentsModal(props) {
  return (
    <Modal
      isOpen={props.visible}
      onRequestClose={props.closeModal}
      style={customStyles}
    >
      <div className="documents-modal">
        <div className="documents-modal-header">
          <h2>Документы</h2>
          <button onClick={props.closeModal} className="documents-modal-close">×</button>
        </div>
        <div className="documents-modal-body">
          <div className="document-item">
            <h3>Политика конфиденциальности</h3>
            <a href={DOCUMENTS.privacy} target="_blank" rel="noopener noreferrer" className="document-download-link">
              Скачать документ
            </a>
          </div>
          <div className="document-item">
            <h3>Пользовательское соглашение</h3>
            <a href={DOCUMENTS.terms} target="_blank" rel="noopener noreferrer" className="document-download-link">
              Скачать документ
            </a>
          </div>
          <div className="document-item">
            <h3>Политика обработки персональных данных</h3>
            <a href={DOCUMENTS.personalData} target="_blank" rel="noopener noreferrer" className="document-download-link">
              Скачать документ
            </a>
          </div>
          <div className="document-item">
            <h3>Согласие на обработку персональных данных</h3>
            <a href={DOCUMENTS.agreement} target="_blank" rel="noopener noreferrer" className="document-download-link">
              Скачать документ
            </a>
          </div>
          <div className="document-item">
            <h3>Политика использования файлов cookies</h3>
            <a href={DOCUMENTS.cookies} target="_blank" rel="noopener noreferrer" className="document-download-link">
              Скачать документ
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DocumentsModal;
